<template>
  <div v-if="boards.length > 0">
    <b v-b-toggle="'team-board' +  team.id" class="team-board-header">{{ team.name }}<span class="oi oi-chevron-top"></span></b>
    <b-collapse visible :id="'team-board' + team.id">
      <b-card-group columns>
        <BoardCard v-for="board in boards" v-bind:key="board.id" :board="board"/>
      </b-card-group>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BoardCard from './BoardCard'
export default {
  name: 'TeamBoards',
  props: {
    team: Object
  },
  components: {
    BoardCard
  },
  data () {
    return {
      boards: []
    }
  },
  created () {
    this.getBoards()
  },
  methods: {
    getBoards () {
      var vm = this
      this.$http
        .get('/boards', { params: { user_id: this.currentUser.id, team_id: this.team.id } })
        .then(function (response) {
          vm.boards = response.data
        })
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  }
}
</script>

<style scoped>
.team-board-header .oi-chevron-top {
  transform: translateY(-2px);
  margin-left: 5px;
  font-size: 12px;
}
.team-board-header.collapsed .oi-chevron-top {
  transform: translateY(-2px) rotateX(180deg);
}
</style>



// WEBPACK FOOTER //
// src/components/TeamBoards.vue